export const ENROLL_SUBMISSION_ERROR = 'ENROLL_SUBMISSION_ERROR_STOREFRONT';
export const ENROLL_SUBMISSION_SUCCESS = 'ENROLL_SUBMISSION_SUCCESS_STOREFRONT';
